import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {CardTitleWrapper} from "../misc/card-tite/card-title.wrapper";
import type {DeviceUtils} from "../../../infrastructure/utils/device-utils";

export class VideoEmbeddedCardTitleProps extends BaseProps {
  title: String;
  device: DeviceUtils;
  shouldRenderCardWrapper: Boolean
}

export const VideoEmbeddedCardTitle = ({
                                         title,
                                         device,
                                         shouldRenderCardWrapper,
                                         children
                                       }: VideoEmbeddedCardTitleProps) => {
  const titleProps = {
    title,
    controller: {device},
  }

  return (shouldRenderCardWrapper ?
          <CardTitleWrapper {...titleProps}>
            {children}
          </CardTitleWrapper> : <>{children}</>

  )
};
